import "./fuyaozi-taboo-style.scss";

//—— 占卦禁忌 ——
//
//  覆述動畫（動畫 2）演完、扣券之前跳出來，使用者確認過才真的起卦。
//
//  —— 為什麼擺在這個位置 ——
//  它不只是免責聲明，是儀式的一部分：看完這幾條再按下去，那個「我確定要問」
//  才有重量。擺在送出問題之前的話，使用者還在想怎麼措辭，沒有人會讀。
//
//  —— 為什麼不用通用的 ConfirmDialog ——
//  那支的 message 是單一段落，而這裡是一串編號清單，塞進一個 <p> 會糊成一團。
//  「需要問卦券」那個提示仍然用 ConfirmDialog（見 fuyaozi-ask-page）。

//禁忌。資料表驅動：改文字只動這張表，序號由 <ol> 自己長。
//
//  內容照伏爻子那一派的規矩（Kevin 2026-10-07 提供）。
//
//  原本還有一條「晚上 10 點 30 ～ 11 點 30，以及交節氣時不占」，
//  2026-10-07 拿掉了 —— 那是**時間性**的禁忌，寫在這裡只是提醒，
//  程式並沒有在那個時段真的擋下來。要做的話得在起卦時比對 castTime
//  的時辰與節氣，而不是靠使用者自己看著辦。
const TABOOS = [
  "心不誠則不占。",
  "一事一卦，不可反覆問卦。",
  "不能在污穢之地或氣場不穩之處占卜。",
  "避免在情緒激動或心神不寧時占卜。",
  "避免隨意測驗卦準不準。",
  "搖卦時避免他人干擾。",
  "違背倫理、道德之事不占。",
  "無意義之事不占。",
];

//  open      是否顯示
//  onConfirm 按下「我已詳閱，起卦」
//  onCancel  按下「再想想」—— 這時候還沒扣券，退出去不會有損失
//
//  —— 點遮罩**不會**關掉（Kevin 2026-10-08 決定）——
//  這一關是儀式的一部分，不是可以隨手撥開的提示。而且下一步會扣券，
//  手指在畫面上滑一下就把它關掉、再納悶「怎麼沒反應」是很糟的。
//  要離開只有一條路：按「再想想」。
const FuyaoziTaboo = ({ open, onConfirm, onCancel }) => {
  if (!open) return null;

  return (
    <div className="fuyaozi-taboo">
      <div
        className="fuyaozi-taboo__box"
        role="dialog"
        aria-modal="true"
        aria-labelledby="fuyaozi-taboo-title"
      >
        <h3 className="fuyaozi-taboo__title" id="fuyaozi-taboo-title">
          占卦禁忌
        </h3>

        <ol className="fuyaozi-taboo__list">
          {TABOOS.map((text) => (
            <li key={text}>{text}</li>
          ))}
        </ol>

        <div className="fuyaozi-taboo__actions">
          <button
            type="button"
            className="fuyaozi-taboo__btn"
            onClick={onCancel}
          >
            再想想
          </button>
          <button
            type="button"
            className="fuyaozi-taboo__btn is-primary"
            onClick={onConfirm}
          >
            我已詳閱，起卦
          </button>
        </div>
      </div>
    </div>
  );
};

export default FuyaoziTaboo;
